/**
 * SSR-safe model-label lookup. Must stay DOM-free so the Express host can
 * import it for meta resolution — do NOT swap this for `inference/modelInfo.ts`,
 * which reads `window.location.hostname` at module load and crashes under Node.
 *
 * Unfiltered by env on purpose: meta is public catalog copy, not per-env availability.
 */
import modelsJson from '@wandb/weave/components/PagePanelComponents/Home/Browse3/inference/modelsFinal.json';

type MinimalModel = {
  id: string;
  label?: string;
};

const MODELS_BY_ID: Map<string, MinimalModel> = new Map(
  (modelsJson as {models: MinimalModel[]}).models.map(m => [m.id, m])
);

/**
 * Returns the model's human-readable display label for a given catalog id
 * (e.g. `cw_openai_gpt-oss-120b` → `OpenAI GPT OSS 120B`), or `undefined`
 * when the id is not found in the bundled catalog.
 */
export function getModelLabelById(modelId: string): string | undefined {
  const model = MODELS_BY_ID.get(modelId);
  if (model == null) {
    return undefined;
  }
  return model.label ?? model.id.split('/').pop();
}
